import type {
    FormationEditionInput,
    FormationId,
    FormationSummary,
} from '@wwf/sdk';
import { RAFile } from './types';

export type FormationInput = FormationEditionInput & {
    id?: FormationId;
    coverInput?: RAFile;
};

export function formationSummaryToInput(
    summary: FormationSummary
): FormationInput {
    const { cover, createdAt, updatedAt, organizationId, ...edition } = summary;

    return {
        ...edition,
        coverId: cover?.id ?? null,
    };
}
